import { Component, AfterViewInit, ElementRef, ViewChild, ViewEncapsulation, OnInit } from '@angular/core';
import { FormBroadcast, FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { Doctor as DoctorKyruus } from 'src/app/angular-elements/medical-information/doctor-information-kyruus/configs/interfaces/doctors.interface';
import { Doctor as DoctorSapphireDigital } from 'src/app/angular-elements/medical-information/doctor-information-kyruus/configs/interfaces/doctors.interface';

@FormComponentLookup('form-doctor-information')
@Component({
    selector: 'app-form-doctor-information',
    templateUrl: './form-doctor-information.component.html',
    styleUrls: ['./form-doctor-information.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormDoctorInformation extends FormEntryComponentClass implements AfterViewInit {

  @ViewChild('entryRef') entryRef: ElementRef;
  value: any = [];

  market: "Senior" | "Individual" | string = null;

  baseEvent: FormBroadcast = {
    formControlName: 'hasAnyDoctorsAdded',
    type: 'valueChange',
    value: null
  };

  constructor() {
    super();
  }

  ngOnInit() {
    this.market = this.entry.custom?.market ? this.entry.custom?.market : "Senior";
  }

  ngAfterViewInit(): void {
    this.initTriggers();
  }

  /**
   * @description Sets up formListeners and formBroadcasters
   */
  initTriggers() {
    this.subscribeToFormStream(this.entry.base.formListeners);
  }

  doctorsChanged(doctors: (DoctorKyruus | DoctorSapphireDigital)[]) {
    if (doctors.length) {
      this.baseEvent.value = true;
    }
    else {
      this.baseEvent.value = false;
    }

    this.formStreamTrigger.triggerFormStream(this.baseEvent);
  }
}
